import axios from "axios";
import baseUrl from "../config";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const getIngredients = async () => {
  try {
    const response = await axiosInstance.get("/pizza-api/ingredients");
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

const getOrders = async (cb) => {
  try {
    const response = await axiosInstance.get("/pizza-api/orders");
    cb(response.data);
  } catch (err) {
    console.log(err);
  }
};

const createOrder = async (order) => {
  try {
    const response = await axiosInstance.post("/pizza-api/orders", order);
    return response.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
};

export { getIngredients, getOrders, createOrder };
